import React, { useContext } from 'react'
import { useTranslation } from 'react-i18next'
import Multistep from 'components/multistep/Multistep'
import { LifeCycleStatus } from 'constants/enums/lifeCycleStatus'
import { ApplicationDispatchContext } from 'contexts/ApplicationContext'
import { IApplicationContext } from 'interfaces/i-application-context-props'
import { IMultistepComponent } from 'interfaces/i-multistep'
import { CheckIsLifeCycleStatus } from 'utils/loanHelpers'
import { UrlStatus } from 'constants/enums/signingUrlTypes'
import LoanOfferDe from 'components/application-blocks/application-offer-blocks/LoanOffer/LoanOfferDe'
import { FillPersonalDataDe } from 'components/application-blocks/application-offer-blocks/FillPersonalData/FillPersonalDataDe'
import { SignPsd2De } from 'components/application-blocks/application-offer-blocks/SignPsd2/SignPsd2De'
import { SignPnDe } from 'components/application-blocks/application-offer-blocks/SignPn/SignPnDe/SignPnDe'
import ThankYou from 'components/application-blocks/common-blocks/ThankYou/ThankYou'
import { UploadDocumentsDe } from 'components/application-blocks/application-offer-blocks/UploadDocuments/UploadDocumentsDe'
import { InfoBox } from 'components/message-boxes/information-box/InformationBox'
import appConfig from 'app.config'

export const LoanApplicationStepsDe = () => {
	const { loanApplication }: IApplicationContext = useContext(
		ApplicationDispatchContext,
	)
	const { t } = useTranslation()
	const loanApplicationSteps: IMultistepComponent[] = [
		{
			id: 1,
			header: 'FillPersonalData',
			body: <FillPersonalDataDe />,
			show: CheckIsLifeCycleStatus(
				[LifeCycleStatus.MultiStepUpdatePersonalData],
				loanApplication.applicationData?.lifeCycleStatus!,
			),
			stepCompleted: false,
		},
		{
			id: 2,
			header: 'PSD2',
			body: <SignPsd2De />,
			show: CheckIsLifeCycleStatus(
				[
					LifeCycleStatus.MultiStepUpdatePersonalData,
					LifeCycleStatus.WaitingForBankData,
				],
				loanApplication.applicationData?.lifeCycleStatus!,
			),
			stepCompleted: false,
		},
		{
			id: 3,
			header: 'UpdateLoanOfferHeader',
			body: <LoanOfferDe />,
			show: CheckIsLifeCycleStatus(
				[
					LifeCycleStatus.MultiStepUpdatePersonalData,
					LifeCycleStatus.WaitingForBankData,
					LifeCycleStatus.PrintPromissoryNote,
				],
				loanApplication.applicationData?.lifeCycleStatus!,
			),
			stepCompleted: false,
		},
		{
			id: 4,
			header: 'SignPn',
			body: <SignPnDe />,
			show:
				loanApplication.applicationData?.signingUrls
					.onlineIdentification.status !== UrlStatus.Signed &&
				CheckIsLifeCycleStatus(
					[
						LifeCycleStatus.ReceiveSigning,
						LifeCycleStatus.MultiStepUpdatePersonalData,
						LifeCycleStatus.WaitingForBankData,
						LifeCycleStatus.PrintPromissoryNote,
					],
					loanApplication.applicationData?.lifeCycleStatus!,
				),
			stepCompleted: false,
		},
		{
			id: 5,
			header: 'UploadDocument',
			body: <UploadDocumentsDe />,
			show: CheckIsLifeCycleStatus(
				[LifeCycleStatus.DocumentsUpload],
				loanApplication.applicationData?.lifeCycleStatus!,
			),
			stepCompleted: false,
		},
		{
			id: 6,
			header: 'ThankYouHeader',
			body: <ThankYou />,
			show: CheckIsLifeCycleStatus(
				[
					LifeCycleStatus.MultiStepUpdatePersonalData,
					LifeCycleStatus.WaitingForBankData,
					LifeCycleStatus.PrintPromissoryNote,
					LifeCycleStatus.ReceiveSigning,
					LifeCycleStatus.CustomerVerification,
					LifeCycleStatus.InternalCheck,
					LifeCycleStatus.DocumentsUpload,
					LifeCycleStatus.SendToBo,
				],
				loanApplication.applicationData?.lifeCycleStatus!,
			),
			stepCompleted: false,
		},
		{
			id: 7,
			header: 'DisbursedHeader',
			body: (
				<InfoBox
					infoType="info"
					css={'application-status-box-info'}
					message={t('StatusTextDisbursed', {
						company: appConfig.companyName,
					})}
				/>
			),
			show: CheckIsLifeCycleStatus(
				[LifeCycleStatus.Disbursed],
				loanApplication.applicationData?.lifeCycleStatus!,
			),
			stepCompleted: false,
		},
		{
			id: 8,
			header: 'ApplicationReviewedHeader',
			body: (
				<InfoBox
					infoType="info"
					css={'application-status-box-info'}
					message={t('CreditDecisionInvestigation')}
				/>
			),
			show: CheckIsLifeCycleStatus(
				[
					LifeCycleStatus.ApplicationReceived,
					LifeCycleStatus.CreditDecisionError,
					LifeCycleStatus.CreditDecisionInvestigation,
				],
				loanApplication.applicationData?.lifeCycleStatus!,
			),
			stepCompleted: false,
		},
	]

	return (
		<Multistep
			multisteps={loanApplicationSteps}
			resetInitialState={false}
		/>
	)
}
